"use client";
import React, { useState, useEffect } from "react";
import AppLogo from "@/components/ui/AppLogo";

const navLinks = [
  { href: "#vorteile", label: "Vorteile" },
  { href: "#leistungen", label: "Leistungen" },
  { href: "#preise", label: "Preise" },
  { href: "#galerie", label: "Galerie" },
  { href: "#faq", label: "FAQ" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#08080F]/90 backdrop-blur-xl border-b border-white/[0.06] py-4"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 group">
          <AppLogo size={48} />
          <div className="hidden sm:block">
            <div className="font-display font-extrabold text-sm text-white leading-none">PC Build Service</div>
            <div className="font-mono text-[9px] text-violet-400 uppercase tracking-widest mt-0.5">Schweiz</div>
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks?.map((l) => (
            <a key={l?.href} href={l?.href} className="nav-link">
              {l?.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden lg:block">
          <a href="#kontakt" className="btn-primary text-xs py-3 px-6">
            Kontakt
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden flex flex-col gap-1.5 p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü öffnen"
        >
          <div className={`w-6 h-0.5 bg-white transition-all ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
          <div className={`w-4 h-0.5 bg-white transition-all ${menuOpen ? "opacity-0" : ""}`} />
          <div className={`w-6 h-0.5 bg-white transition-all ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>
      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-[#0E0E1A]/95 backdrop-blur-xl border-t border-white/[0.06] px-6 py-6 space-y-4">
          {navLinks?.map((l) => (
            <a
              key={l?.href}
              href={l?.href}
              className="block font-display font-semibold text-white/60 hover:text-white transition-colors py-2"
              onClick={() => setMenuOpen(false)}
            >
              {l?.label}
            </a>
          ))}
          <a
            href="#kontakt"
            className="btn-primary block text-center mt-4"
            onClick={() => setMenuOpen(false)}
          >
            Kontakt aufnehmen
          </a>
        </div>
      </div>
    </nav>
  );
}